var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "content-wrap",
    },
    [
      _c(
        "el-card",
        { staticClass: "card--box" },
        [
          _c(
            "div",
            {
              staticClass: "header--title",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("after-sales::after-sale-list::new_order_info")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  staticClass: "form-container",
                  attrs: {
                    model: _vm.editForm,
                    rules: _vm.rules,
                    "label-position": "top",
                    "label-width": "auto",
                  },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_order_num"
                            ),
                            prop: "orderNo",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "form-item",
                              attrs: { readonly: "", placeholder: "--" },
                              model: {
                                value: _vm.editForm.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "orderNo", $$v)
                                },
                                expression: "editForm.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.orderVisiable = true
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "position-item", attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_after_sale_type"
                            ),
                            prop: "afterSaleId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-item" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "form-item",
                                  attrs: {
                                    placeholder: _vm.t(
                                      "after-sales::after-sale-list::new_after_sale_type_holder"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.editForm.afterSaleId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editForm, "afterSaleId", $$v)
                                    },
                                    expression: "editForm.afterSaleId",
                                  },
                                },
                                _vm._l(_vm.afterTypes, function (i) {
                                  return _c("el-option", {
                                    key: i.id,
                                    attrs: { label: i.name, value: i.id },
                                  })
                                }),
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value:
                                        "after-sales::after-sales-set::type-add",
                                      expression:
                                        "'after-sales::after-sales-set::type-add'",
                                    },
                                  ],
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t(
                                      "system::common::text::add"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus add-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleTypes("afterTypes")
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "position-item", attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_refund"
                            ),
                            prop: "refundTypeId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-item" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "form-item",
                                  attrs: {
                                    placeholder: _vm.t(
                                      "after-sales::after-sale-list::new_refund_holder"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.editForm.refundTypeId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editForm,
                                        "refundTypeId",
                                        $$v
                                      )
                                    },
                                    expression: "editForm.refundTypeId",
                                  },
                                },
                                _vm._l(_vm.refundTypes, function (i) {
                                  return _c("el-option", {
                                    key: i.id,
                                    attrs: { label: i.name, value: i.id },
                                  })
                                }),
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value:
                                        "after-sales::after-sales-set::refund-add",
                                      expression:
                                        "'after-sales::after-sales-set::refund-add'",
                                    },
                                  ],
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t(
                                      "system::common::text::add"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus add-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleTypes("refundTypes")
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "position-item", attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_source"
                            ),
                            prop: "sourceId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-item" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "form-item",
                                  attrs: {
                                    placeholder: _vm.t(
                                      "after-sales::after-sale-list::new_refund_source_holder"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.editForm.sourceId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editForm, "sourceId", $$v)
                                    },
                                    expression: "editForm.sourceId",
                                  },
                                },
                                _vm._l(_vm.afterSources, function (i) {
                                  return _c("el-option", {
                                    key: i.id,
                                    attrs: { label: i.name, value: i.id },
                                  })
                                }),
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value:
                                        "after-sales::after-sales-set::source-add",
                                      expression:
                                        "'after-sales::after-sales-set::source-add'",
                                    },
                                  ],
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t(
                                      "system::common::text::add"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus add-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleTypes("afterSources")
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "position-item", attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_reason"
                            ),
                            prop: "refundReasonId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-item" },
                            [
                              _c("el-cascader", {
                                ref: "reasonTree",
                                staticClass: "form-item",
                                attrs: {
                                  options: _vm.afterReasons,
                                  placeholder: _vm.t(
                                    "after-sales::after-sale-list::new_refund_reason_holder"
                                  ),
                                  props: { expandTrigger: "hover" },
                                  clearable: "",
                                },
                                on: { change: _vm.changeReason },
                                model: {
                                  value: _vm.editForm.refundReasonId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editForm,
                                      "refundReasonId",
                                      $$v
                                    )
                                  },
                                  expression: "editForm.refundReasonId",
                                },
                              }),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value:
                                        "after-sales::after-sales-set::reason-add",
                                      expression:
                                        "'after-sales::after-sales-set::reason-add'",
                                    },
                                  ],
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t(
                                      "system::common::text::add"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus add-btn",
                                    on: { click: _vm.handlerAddCateGory },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_responsible_party"
                            ),
                            prop: "dutyId",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item",
                            attrs: { readonly: "" },
                            model: {
                              value: _vm.duty,
                              callback: function ($$v) {
                                _vm.duty = $$v
                              },
                              expression: "duty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_shop_order_num"
                            ),
                            prop: "sourceNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item",
                            attrs: {
                              placeholder: _vm.t(
                                "after-sales::after-sale-list::new_shop_order_num_holder"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.editForm.sourceNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "sourceNo", $$v)
                              },
                              expression: "editForm.sourceNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 6, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_bill_num"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item",
                            attrs: {
                              placeholder: _vm.t(
                                "after-sales::after-sale-list::new_bill_num_holder"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.editForm.billNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "billNo", $$v)
                              },
                              expression: "editForm.billNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "8px" },
                          attrs: {
                            label:
                              _vm.t(
                                "after-sales::after-sale-list::new_bill_attachement"
                              ) + "(10M)",
                          },
                        },
                        [
                          _c("z-upload", {
                            attrs: {
                              limit: 5,
                              multiple: true,
                              accept: "png,jpg,xlsx,xls",
                            },
                            model: {
                              value: _vm.attachments,
                              callback: function ($$v) {
                                _vm.attachments = $$v
                              },
                              expression: "attachments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card--box" },
        [
          _c(
            "div",
            {
              staticClass: "header--title",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.t("after-sales::after-sale-list::new_order_info")
                  ) +
                  " "
              ),
            ]
          ),
          _c("z-table", {
            ref: "tableData",
            staticClass: "prodinfo--edit__table",
            attrs: {
              columns: _vm.tableColumns,
              data: _vm.editForm.subVos,
              "max-height": 500,
              pagination: false,
              "row-key": "orderItemNo",
            },
            on: { "selection-change": _vm.handleSelectionChange },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "sku-wrap" },
                      [
                        _c("el-image", {
                          staticClass: "sku-img",
                          attrs: {
                            "preview-src-list": [row.imageUrl],
                            src: row.imageUrl,
                            alt: "",
                          },
                        }),
                        _c(
                          "el-tooltip",
                          { attrs: { content: row.title, placement: "top" } },
                          [
                            _c("div", { staticClass: "sku-title" }, [
                              _vm._v(_vm._s(row.title)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "fulfillmentStatus",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.filterStatus(row.fulfillmentStatus))),
                    ]),
                  ]
                },
              },
              {
                key: "amount",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "row-input",
                        attrs: { disabled: !row.status },
                        model: {
                          value: row.refundType,
                          callback: function ($$v) {
                            _vm.$set(row, "refundType", $$v)
                          },
                          expression: "row.refundType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_select_amount"
                            ),
                            value: "1",
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_select_proportion"
                            ),
                            value: "2",
                          },
                        }),
                      ],
                      1
                    ),
                    row.refundType === "2"
                      ? _c("el-input-number", {
                          staticClass: "row-input",
                          attrs: {
                            disabled: !row.status,
                            max: 100,
                            min: 0,
                            "controls-position": "right",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.changeAmount(row, "amount")
                            },
                          },
                          model: {
                            value: row.refundPercent,
                            callback: function ($$v) {
                              _vm.$set(row, "refundPercent", $$v)
                            },
                            expression: "row.refundPercent",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            "" +
                            _vm.t(
                              "after-sales::after-sale-list::max_refound_money"
                            ) +
                            (row.canRefundPayAmount || 0),
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticClass: "row-input",
                          attrs: {
                            disabled: !row.status || row.refundType === "2",
                            min: 0,
                            "controls-position": "right",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.blurPrice(row)
                            },
                          },
                          model: {
                            value: row.amount,
                            callback: function ($$v) {
                              _vm.$set(row, "amount", $$v)
                            },
                            expression: "row.amount",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "refundShipAmount",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "row-input",
                        attrs: { disabled: !row.status },
                        model: {
                          value: row.refundShipType,
                          callback: function ($$v) {
                            _vm.$set(row, "refundShipType", $$v)
                          },
                          expression: "row.refundShipType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_select_amount"
                            ),
                            value: "1",
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.t(
                              "after-sales::after-sale-list::new_select_proportion"
                            ),
                            value: "2",
                          },
                        }),
                      ],
                      1
                    ),
                    row.refundShipType === "2"
                      ? _c("el-input-number", {
                          staticClass: "row-input",
                          attrs: {
                            disabled: !row.status,
                            max: 100,
                            min: 0,
                            "controls-position": "right",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.changeAmount(row, "refundShipAmount")
                            },
                          },
                          model: {
                            value: row.refundShipPercent,
                            callback: function ($$v) {
                              _vm.$set(row, "refundShipPercent", $$v)
                            },
                            expression: "row.refundShipPercent",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            "" +
                            _vm.t(
                              "after-sales::after-sale-list::max_refound_email"
                            ) +
                            (row.canRefundShipAmount || 0),
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticClass: "row-input",
                          attrs: {
                            disabled: !row.status || row.refundShipType === "2",
                            min: 0,
                            "controls-position": "right",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.blurPrice(row)
                            },
                          },
                          model: {
                            value: row.refundShipAmount,
                            callback: function ($$v) {
                              _vm.$set(row, "refundShipAmount", $$v)
                            },
                            expression: "row.refundShipAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-form",
            { attrs: { "label-position": "top", "label-width": "90px" } },
            [
              _c("div", { staticClass: "mb-16 mt-16" }, [
                _c("span", { staticStyle: { width: "90px" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.t(
                        "after-sales::after-sale-list::new_after_sale_amount"
                      )
                    )
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.refundTotalAmount) +
                      " " +
                      _vm._s(_vm.editForm.currency)
                  ),
                ]),
              ]),
              _c("el-divider", { staticClass: "mb-16 mt-24" }),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.t("after-sales::after-sale-list::new_remark"),
                    prop: "remark",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      maxlength: 50,
                      placeholder: _vm.t(
                        "after-sales::after-sale-list::new_placeholder"
                      ),
                      rows: 3,
                      "show-word-limit": "",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.editForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "remark", $$v)
                      },
                      expression: "editForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "footer-fixed",
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.t("after-sales::after-sale-list::new_return")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "mlr16",
              attrs: {
                loading: _vm.saveLoading,
                size: "small",
                type: "primary",
              },
              on: { click: _vm.handleSave },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.t("after-sales::after-sale-list::new_save")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("cateModal", {
        attrs: { cateData: _vm.cateInfoData, visible: _vm.cateInfoModal },
        on: {
          "update:visible": function ($event) {
            _vm.cateInfoModal = $event
          },
          save: function ($event) {
            return _vm.initUpdate("afterReasons")
          },
        },
      }),
      _c("addModal", {
        attrs: { drawRow: _vm.typeRow },
        on: { save: _vm.initUpdate },
        model: {
          value: _vm.typeVisable,
          callback: function ($$v) {
            _vm.typeVisable = $$v
          },
          expression: "typeVisable",
        },
      }),
      _c("OrderDialog", {
        on: { changeNo: _vm.changeNo },
        model: {
          value: _vm.orderVisiable,
          callback: function ($$v) {
            _vm.orderVisiable = $$v
          },
          expression: "orderVisiable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }